import React from 'react';

const Maestro = ({ width = '24', height = '24', className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={className}
      width={width}
      height={height}
      {...rest}
    >
      <path d="M0 0h24v24H0z" fill="#FEFEFE" />
      <path
        d="M6 6h12.06v12.06h-5.04a7.62 7.62 0 0 1 0.329 -0.209c0.72 -0.435 1.127 -1.008 1.351 -1.831 0.073 -0.844 -0.039 -1.611 -0.6 -2.28 -0.416 -0.453 -0.981 -0.852 -1.615 -0.911 -0.985 -0.028 -1.694 0.121 -2.447 0.798 -0.52 0.544 -0.707 1.263 -0.694 1.995 0.04 0.591 0.217 1.054 0.555 1.538l0.131 0.191c0.207 0.207 0.433 0.348 0.683 0.498C10.86 17.94 10.86 17.94 10.98 18.06h-4.98z"
        fill="#141414"
      />
      <path
        d="m10.02 13.62 0.18 0.06c-0.11 0.189 -0.226 0.367 -0.36 0.54l-0.12 -0.24z"
        fill="#F0F0F0"
      />
      <path d="m10.5 17.76 0.48 0.24v0.06h-0.48z" fill="#1F1F1F" />
    </svg>
  );
};

export default Maestro;
